export default __webpack_public_path__ + "static/media/youtube.dd98cff5.svg";